// extracted by mini-css-extract-plugin
module.exports = {"iconBell":"NotificationsList_iconBell__1l2Rq"};